import React, { useEffect, useState } from "react";
import { UiWhiteCard } from "../../../_uiComponents/common/UiWhiteCard";
import { UiIconButton } from "../../../_uiComponents/common/UiButton";
import { PlusIcon } from "../../../../styles/img/svg/PlusIcon";
import UiSelectM from "../../../_uiComponents/common/UiSelectCard";
import { MenuItem } from "@mui/material";
import { TabPanel } from "@mui/lab";
import { useDispatch, useSelector, useStore } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  schedulePaymentsListRequest,
  setActiveListType,
  setActiveView,
  setFilterPaymentStatus,
  setScheduleDetailActiveTab,
  setSchedulePaymentsDetails,
} from "../../../../_redux/_actions/schedulePayments.actions";
import { UiNavTab } from "../../../_uiComponents/common/UiNavTab";
import { schedulePaymentsConstants } from "../../../../_redux/_constants";
import { UiSchedulePaymentsSummaryCard } from "../../../_uiComponents/SchedulePayments/UiSchedulePaymentSummaryCard";
import UISchedulePaymentsEmpty from "../../../_uiComponents/SchedulePayments/UISchedulePaymentsEmpty";
import { UiGrayBgLoader } from "../../../_uiComponents/common/UiGrayBgLoader";

const SchedulePayments = () => {
  const {
    schedulePaymentsList,
    isListLoading,
    listHasMore: listHasMoreRaw,
    listType,
    filterPaymentStatus,
  } = useSelector((state) => state.schedulePayments);

  const getScheduledType = (tabType) => {
    if (tabType === schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER) {
      return schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER;
    } else if (tabType === schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT) {
      return schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_BILL;
    } else if (tabType === schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT) {
      return schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_CARD_SETTLEMENT;
    }
    return undefined; // ALL
  };

  const tabList = [
    {
      id: 1,
      label: "All",
      value: "ALL",
    },
    {
      id: 2,
      label: "Fund Transfer",
      value: schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER,
    },
    {
      id: 3,
      label: "Bill Payment",
      value: schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_BILL,
    },
    {
      id: 4,
      label: "Card Settlement",
      value: schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_CARD_SETTLEMENT,
    },
  ];

  const filterStatusList = [
    {
      id: 1,
      label: "Active",
      value:
        schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE,
    },
    {
      id: 2,
      label: "Completed",
      value:
        schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED,
    },
    {
      id: 3,
      label: "Stopped",
      value:
        schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED,
    },
  ];

  const dispatch = useDispatch();
  const store = useStore();

  const listHasMore = listHasMoreRaw !== false;

  const buildListRequestPayload = (pageStart, pageEnd, tab, status) => ({
    pageStart,
    pageEnd,
    type: tab,
    scheduleStatus: status,
    ...(getScheduledType(tab) ? { scheduledType: getScheduledType(tab) } : {}),
  });

  // initial load
  useEffect(() => {
    dispatch(
      schedulePaymentsListRequest(
        buildListRequestPayload(0, 9, listType, filterPaymentStatus),
      ),
    );
  }, [dispatch]);

  const hndleListRequest = (pageStart, pageEnd, tab, status) => {
    dispatch(
      schedulePaymentsListRequest(
        buildListRequestPayload(pageStart, pageEnd, tab, status),
      ),
    );
  };

  /** Dispatch next page only when idle (read store so duplicate scroll calls see loading after first dispatch). */
  const handleLoadMore = () => {
    const sp = store.getState().schedulePayments;
    if (sp.isListLoading || sp.listHasMore === false) return;
    const loadedCount = sp.schedulePaymentsList?.[listType]?.length ?? 0;
    if (loadedCount === 0) return;

    const nextStart = loadedCount;
    const nextEnd = nextStart + 9;
    dispatch(
      schedulePaymentsListRequest(
        buildListRequestPayload(
          nextStart,
          nextEnd,
          listType,
          filterPaymentStatus,
        ),
      ),
    );
  };

  const handleShedulePaymentDetailView = (item) => {
    dispatch(setSchedulePaymentsDetails(item));
    dispatch(
      setScheduleDetailActiveTab(
        schedulePaymentsConstants.SCHEDULE_DETAIL_TAB_UPCOMING_SCHEDULES,
      ),
    );

    dispatch(
      setActiveView(
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_SUMMARY,
      ),
    );
  };

  return (
    <div className="df-db-left df-schedule-payments">
      <UiWhiteCard className="mt-0 df-mh-wf df-pad-30">
        <div className="df-schedule-icon-btn mb-2">
          <UiIconButton
            icon={<PlusIcon />}
            name="Schedule a Payment"
            size={"lg"}
            variant="primary"
            className="df-schedule-icon-btn__content df-ui-dark-bg-btn"
            onClick={() =>
              dispatch(
                setActiveView(
                  schedulePaymentsConstants.ACTIVE_VIEW_SELECT_SCHEDULE_PAYMENT_TYPE,
                ),
              )
            }
          />
        </div>
        <UiNavTab
          tabNav={tabList}
          value={listType}
          onSelect={(selectedTab) => {
            dispatch(setActiveListType(selectedTab));
            hndleListRequest(0, 9, selectedTab, filterPaymentStatus);
          }}
          className="df-db-tab-wrapper"
        >
          <div className="df-schedule-payment-status-wrapper">
            <UiSelectM
              label="Payment Status"
              value={filterPaymentStatus}
              onChange={(e) => {
                dispatch(setFilterPaymentStatus(e.target.value));
                hndleListRequest(0, 9, listType, e.target.value);
              }}
            >
              {filterStatusList.map((item) => (
                <MenuItem key={item?.id} value={item?.value}>
                  {item?.label}
                </MenuItem>
              ))}
            </UiSelectM>
          </div>

          {/* all tab */}
          <TabPanel
            value={schedulePaymentsConstants.TAB_TYPE_ALL}
            className="df-pad-lr-0"
          >
            <InfiniteScroll
              dataLength={
                schedulePaymentsList?.[schedulePaymentsConstants.TAB_TYPE_ALL]
                  ?.length || 0
              }
              next={handleLoadMore}
              hasMore={
                listType === schedulePaymentsConstants.TAB_TYPE_ALL &&
                listHasMore
              }
              loader={
                Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_ALL
                  ],
                ) &&
                schedulePaymentsList?.[schedulePaymentsConstants.TAB_TYPE_ALL]
                  ?.length > 0 ? (
                  <UiGrayBgLoader className="df-ch-130" />
                ) : null
              }
            >
              {schedulePaymentsList?.[schedulePaymentsConstants.TAB_TYPE_ALL]
                ?.length === 0 && !isListLoading ? (
                <UISchedulePaymentsEmpty />
              ) : Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_ALL
                  ],
                ) &&
                schedulePaymentsList?.[schedulePaymentsConstants.TAB_TYPE_ALL]
                  ?.length > 0 ? (
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_ALL
                ]?.map((schedulePaymentData) => (
                  <UiSchedulePaymentsSummaryCard
                    schedulePaymentData={schedulePaymentData}
                    onClick={() => {
                      handleShedulePaymentDetailView(schedulePaymentData);
                    }}
                  />
                ))
              ) : (
                <UiGrayBgLoader className="df-ch-130" />
              )}
            </InfiniteScroll>
          </TabPanel>

          {/* sheduled fund transfers */}
          <TabPanel
            value={schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER}
            className="df-card-tab df-pad-lr-0"
          >
            <InfiniteScroll
              dataLength={
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                ]?.length || 0
              }
              next={handleLoadMore}
              hasMore={
                listType === schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER &&
                listHasMore
              }
              loader={
                Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                ]?.length > 0 ? (
                  <UiGrayBgLoader className="df-ch-130" />
                ) : null
              }
            >
              {schedulePaymentsList?.[
                schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
              ]?.length === 0 && !isListLoading ? (
                <UISchedulePaymentsEmpty />
              ) : Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                ]?.length > 0 ? (
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_FUND_TRANSFER
                ]?.map((schedulePaymentData) => (
                  <UiSchedulePaymentsSummaryCard
                    schedulePaymentData={schedulePaymentData}
                    onClick={() => {
                      handleShedulePaymentDetailView(schedulePaymentData);
                    }}
                  />
                ))
              ) : (
                <UiGrayBgLoader className="df-ch-130" />
              )}
            </InfiniteScroll>
          </TabPanel>

          {/* scheduled bill payments */}
          <TabPanel
            value={schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT}
            className="df-card-tab df-pad-lr-0"
          >
            <InfiniteScroll
              dataLength={
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                ]?.length || 0
              }
              next={handleLoadMore}
              hasMore={
                listType === schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT &&
                listHasMore
              }
              loader={
                Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                ]?.length > 0 ? (
                  <UiGrayBgLoader className="df-ch-130" />
                ) : null
              }
            >
              {schedulePaymentsList?.[
                schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
              ]?.length === 0 && !isListLoading ? (
                <UISchedulePaymentsEmpty />
              ) : Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                ]?.length > 0 ? (
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_BILL_PAYMENT
                ]?.map((schedulePaymentData) => (
                  <UiSchedulePaymentsSummaryCard
                    schedulePaymentData={schedulePaymentData}
                    onClick={() => {
                      handleShedulePaymentDetailView(schedulePaymentData);
                    }}
                  />
                ))
              ) : (
                <UiGrayBgLoader className="df-ch-130" />
              )}
            </InfiniteScroll>
          </TabPanel>

          {/* scheduled card settlements */}
          <TabPanel
            value={schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT}
            className="df-card-tab df-pad-lr-0"
          >
            <InfiniteScroll
              dataLength={
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                ]?.length || 0
              }
              next={handleLoadMore}
              hasMore={
                listType ===
                  schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT &&
                listHasMore
              }
              loader={
                Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                ]?.length > 0 ? (
                  <UiGrayBgLoader className="df-ch-130" />
                ) : null
              }
            >
              {schedulePaymentsList?.[
                schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
              ]?.length === 0 && !isListLoading ? (
                <UISchedulePaymentsEmpty />
              ) : Array.isArray(
                  schedulePaymentsList?.[
                    schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                  ],
                ) &&
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                ]?.length > 0 ? (
                schedulePaymentsList?.[
                  schedulePaymentsConstants.TAB_TYPE_CARD_SETTLEMENT
                ]?.map((schedulePaymentData) => (
                  <UiSchedulePaymentsSummaryCard
                    schedulePaymentData={schedulePaymentData}
                    onClick={() => {
                      handleShedulePaymentDetailView(schedulePaymentData);
                    }}
                  />
                ))
              ) : (
                <UiGrayBgLoader className="df-ch-130" />
              )}
            </InfiniteScroll>
          </TabPanel>
        </UiNavTab>
      </UiWhiteCard>
    </div>
  );
};

export default SchedulePayments;
